import { createAction, props } from '@ngrx/store';

import { ReceiveOrderList, ReceiveOrderListSearchCriteria, ReceiveOrderView } from '../model/receive-order.model';

export const ReceiveOrderAction = {
  receiveOrderViewRequest: createAction(
    '[Receive Order] receive order view request',
    props<{ payload: { docNo: string; roType: string } }>()
  ),
  receiveOrderViewResponse: createAction(
    '[Receive Order] receive order view response',
    props<{ response: ReceiveOrderView }>()
  ),
  receiveOrderListRequest: createAction(
    '[Receive Order] Receive Order list request',
    props<{ payload: ReceiveOrderListSearchCriteria }>()
  ),
  receiveOrderListResponse: createAction(
    '[Receive Order] Receive Order list response',
    props<{ response: ReceiveOrderList }>()
  ),
  receiveOrderClearViewResponse: createAction('[Receive Order] receive order clear view response'),
  receiveOrderClearListResponse: createAction('[Receive Order] receive order clear list response')
};
